import React, { useCallback, useEffect } from "react";
import cn from "classnames";
import { debounce } from "lodash";
import colorForDesignHomePage from "@/components/common/colorForDesignHomePage";
import { useUserDesign } from "@/states/design.state";
import { useConfig, useGenerateResult } from "@/states/common.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import { useIsloading } from "@/states/ui.state";
import { useMediaQuery } from "react-responsive";
import style from "./Color.module.scss";
import { CustomCSSProperties } from "@/types/ui.types";
const Color = () => {
  const isMobile = useMediaQuery({
    maxWidth: 600
  });
  const {
    color,
    setColor,
    shape
  } = useUserDesign();
  const {
    config,
    files,
    payload
  } = useConfig();
  const {
    result
  } = useGenerateResult();
  const {
    setIsloading
  } = useIsloading();
  const {
    mutateHomeQr,
    mutateLoading
  } = useGenerateHomeQr(false);
  const defaultSelectedColor = config?.frontcolor;
  useEffect(() => {
    if (!defaultSelectedColor || color.frontcolor !== defaultSelectedColor) {
      setColor({
        frontcolor: defaultSelectedColor || "#000000"
      });
    }
  }, [defaultSelectedColor]);
  const handleChangeColor = (e: React.ChangeEvent<HTMLInputElement>, _result: string | null, _shape: {
    edges: string;
  }) => {
    const {
      value
    } = e.target;
    setIsloading(true);
    setColor({
      frontcolor: value
    });
    const newConfig = {
      frontcolor: value,
      marker_top_left: {
        marker: _shape.edges,
        outer_color: value,
        inner_color: value
      },
      sticker_color: value
    };
    mutateHomeQr({
      params: {
        ...payload,
        files
      },
      configParams: newConfig
    });
  };
  const optimizeFn = useCallback(debounce(handleChangeColor, 500), []);
  const handleSelectItem = (backcolor: string) => {
    setIsloading(true);
    setColor({
      frontcolor: backcolor
    });
    const newConfig = {
      frontcolor: backcolor,
      marker_top_left: {
        marker: shape.edges,
        outer_color: backcolor,
        inner_color: backcolor
      },
      sticker_color: backcolor
    };
    if (!result || !mutateLoading) {
      mutateHomeQr({
        params: {
          ...payload,
          files
        },
        configParams: newConfig
      });
    }
  };

  // Sort and filter colors dynamically based on mobile or desktop
  const reorderedColors = isMobile ? colorForDesignHomePage.filter(color => color.is_mobile).sort((a, b) => (a.mobile_sort ?? 0) - (b.mobile_sort ?? 0)) : colorForDesignHomePage;
  return <div className={style.wrapper} data-sentry-component="Color" data-sentry-source-file="Color.tsx">
      <div className={style.flex}>
        <button className={style.colorPicker}>
          <img src={"/home-page/colorpicker.svg"} alt="Color picker" />
          <input type={"color"} onChange={e => optimizeFn(e, result, shape)} />
        </button>
        {reorderedColors.map(({
        backcolor
      }, index) => {
        return <button key={index} className={cn(style.item, {
          [style.active]: color.frontcolor === backcolor
        })} onClick={() => handleSelectItem(backcolor)}>
              <span style={{
            "--bg-color": backcolor
          } as CustomCSSProperties} />

            </button>;
      })}
      </div>
    </div>;
};
export default Color;